<template>
  <div class="h-full w-full md:p-xl p-md">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseLayout',
  setup() {
    return {};
  },
});
</script>
